export default "__VITE_ASSET__DqwLXduU__"